module.exports = __webpack_public_path__ + "static/media/testRide_Selected.d6f74b45.svg";